module.exports = __webpack_public_path__ + "img/noSearch.a93ee6af.png";